import type { MoneyMap } from '@fruitful/types';
import { useCallback } from 'react';

import { useRefetchGetMembershipMoneyMapsMutationOptions } from './useRefetchGetMembershipMoneyMapsMutationOptions';
import { useUpsertMoneyMap } from './useUpsertMoneyMap';

export const useUpdateMoneyMapTitle = (membershipId: string | undefined) => {
    const refetchMutationOptions =
        useRefetchGetMembershipMoneyMapsMutationOptions(membershipId);
    const { mutateAsync: upsertMoneyMap } = useUpsertMoneyMap(
        refetchMutationOptions,
    );

    const updateTitle = useCallback(
        async (moneyMap: MoneyMap, newTitle: string) => {
            if (membershipId == null || membershipId === '') {
                throw new Error('Membership ID is required');
            }

            await upsertMoneyMap({
                body: {
                    id: moneyMap.id,
                    membershipId,
                    title: newTitle,
                    status: moneyMap.status,
                    monthlyIncomeCents: moneyMap.monthlyIncomeCents,
                    incomeMoneyMapAccountId: moneyMap.incomeMoneyMapAccountId,
                },
            });
        },
        [membershipId, upsertMoneyMap],
    );

    return { updateTitle };
};
